import {
  PERIOD_STATUS_ACTIVE,
  PERIOD_STATUS_REJECTED,
  PERIOD_STATUS_APPROVED,
  PERIOD_STATUS_CLOSED,
} from "@/schemas/projectSettlements";
import { SYSTEM_ROLE_CODE } from "@/schemas/user";
import useAccount from "@/modules/account/hooks/useAccount";
import { useIsAdmin } from "@/modules/account/hooks/useIsAdmin";
import { useSettlementQuery } from "./useSettlementQuery";

export const useSettlementPermissions = () => {
  const settlementQuery = useSettlementQuery();
  const { account } = useAccount();
  const isAdmin = useIsAdmin();

  const { period_status } = settlementQuery.data ?? {};
  const systemRoleCode = account?.system_role_code;

  // Status checks
  const isInActiveStatus = period_status === PERIOD_STATUS_ACTIVE;
  const isInRejectedStatus = period_status === PERIOD_STATUS_REJECTED;
  const isInApprovedStatus = period_status === PERIOD_STATUS_APPROVED;
  const isInClosedStatus = period_status === PERIOD_STATUS_CLOSED;

  // Role checks
  const isKAM = systemRoleCode === SYSTEM_ROLE_CODE.KEY_ACCOUNT_MANAGER;
  const isDRKAM = systemRoleCode === SYSTEM_ROLE_CODE.CUSTOMER_SERVICE_DIRECTOR;
  const isDO = systemRoleCode === SYSTEM_ROLE_CODE.OPERATIONAL_DIRECTOR;

  // Visibility by role
  const canKAMApprove = isKAM || isDRKAM || isDO || isAdmin;
  const canDRKAMClose = isDRKAM || isDO || isAdmin;
  const canDRKAMReject = isDRKAM || isDO || isAdmin;
  const canDRKAMReopen = isDRKAM || isDO || isAdmin;

  return {
    isLoading: settlementQuery.isLoading,
    canApprove: canKAMApprove && (isInActiveStatus || isInRejectedStatus),
    canClose:
      canDRKAMClose &&
      (isInActiveStatus || isInApprovedStatus || isInRejectedStatus),
    canReject: canDRKAMReject && isInApprovedStatus,
    canReopen: canDRKAMReopen && isInClosedStatus,
  };
};
